export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "Instant Setup",
  headline: "Zero Knowledege Proof based verification system",
  description:
    "A network of nodes that cryptographically verify and share your data on consent. Providing One click login and Quick user onboarding solutions.",
  buttonLabel: "Learn More",
  imgStart: "",
  img: require("../../images/svg-2.svg"),
  alt: "Vault",
  start: "true",
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "IDentrix Ecosystem",
  headline: "Take back control of your data and digital identity",
  description:
    "It’s time to end the use of similar passwords, insecure databases and bring in frictionless identity management systems.",
  buttonLabel: "Learn More",
  imgStart: "start",
  img: require("../../images/fgp.png"),
  alt: "Vault",
  start: "true",
};

export const homeObjThree = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "An Identity Network for the Decentralised world",
  description:
    "The IDentrix Network is A Layer Of Trust On Web 3.0, designed to bring personal control and ease-of-use of your Identity data.",
  buttonLabel: "Get Started",
  imgStart: "",
  img: require("../../images/hero.PNG"),
  alt: "Credit Card",
  start: "",
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "Marketing Agency",
  headline: "Blockchain based self sovereign identity ",
  description:
    "Blockchain enables more secure management and storage of digital identities by providing unified, interoperable, and tamper-proof infrastructure with key benefits to enterprises and users.",
  buttonLabel: "Learn More",
  imgStart: "",
  img: require("../../images/svg-1.svg"),
  alt: "Credit Card",
  start: "",
};

export const cardData = [
  [
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim",
    },
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim ",
    },
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim",
    },
  ],
  [
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim",
    },
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim",
    },
    {
      img: require("../../images/svg-2.svg"),
      title: "Our Architecture",
      descr: "Dolor sunt consequat sit aute ea fugiat minim ea fugiat minim",
    },
  ],
];

export const FAQdata = [
  {
    q: "How are you maddafakkah?",
    ans: "Adipisicing nisi culpa officia eiusmod commodo quis Lorem in. Deserunt incididunt labore aliquip commodo tempor. Eiusmod officia duis ullamco dolore velit voluptate ut aliqua pariatur pariatur anim sit eiusmod. Fugiat quis cillum et nostrud exercitation et consequat amet consectetur elit cupidatat commodo. Exercitation velit deserunt esse cupidatat aute dolore sunt ad Lorem ex aliqua.",
  },
  {
    q: "How are you maddafakkah?",
    ans: "Adipisicing nisi culpa officia eiusmod commodo quis Lorem in. Deserunt incididunt labore aliquip commodo tempor. Eiusmod officia duis ullamco dolore velit voluptate ut aliqua pariatur pariatur anim sit eiusmod. Fugiat quis cillum et nostrud exercitation et consequat amet consectetur elit cupidatat commodo. Exercitation velit deserunt esse cupidatat aute dolore sunt ad Lorem ex aliqua.",
  },
  {
    q: "How are you maddafakkah?",
    ans: "Adipisicing nisi culpa officia eiusmod commodo quis Lorem in. Deserunt incididunt labore aliquip commodo tempor. Eiusmod officia duis ullamco dolore velit voluptate ut aliqua pariatur pariatur anim sit eiusmod. Fugiat quis cillum et nostrud exercitation et consequat amet consectetur elit cupidatat commodo. Exercitation velit deserunt esse cupidatat aute dolore sunt ad Lorem ex aliqua.",
  },
  {
    q: "How are you maddafakkah?",
    ans: "Adipisicing nisi culpa officia eiusmod commodo quis Lorem in. Deserunt incididunt labore aliquip commodo tempor. Eiusmod officia duis ullamco dolore velit voluptate ut aliqua pariatur pariatur anim sit eiusmod. Fugiat quis cillum et nostrud exercitation et consequat amet consectetur elit cupidatat commodo. Exercitation velit deserunt esse cupidatat aute dolore sunt ad Lorem ex aliqua.",
  },
];
